import { DateTimeFormatStyle } from "@hopper-b2b/i18n";
import {
  type Branding,
  ClientName,
  I18nNamespace,
  type TranslatableBrandAttributes,
  TranslationLanguage,
  ChatAvailability,
} from "@hopper-b2b/types";
import { CUSTOMER_SUPPORT_PATH } from "@hsbc/utilities";

const defaultConfig: TranslatableBrandAttributes = {
  dateFormat: "DD/MM/YYYY",
  portalName: "HSBC Rewards | Travel with Points",
  preferredCountryCode: "QA",
  preferredAreaCode: "+974",
  urls: {
    helpCenterBaseUrl: CUSTOMER_SUPPORT_PATH,
    termsAndConditions: "https://hts.hopper.com/legal/HSBC-QA",
    privacyPolicy: "https://hts.hopper.com/legal/privacy-policy",
    cfarTerms: "https://hts.hopper.com/legal/HSBC-QA",
    disruptionTerms: "https://hts.hopper.com/legal/HSBC-QA",
    hsbcTerms: "https://www.hsbc.com.qa/terms/",
    benefitsFromAirline:
      "https://hts.hopper.com/legal/hts-passenger-rights-overview",
  },
  rewardsPriceFormatterKey: "{{amount}} Points",
  "@rewardsPriceFormatterKey": {
    description:
      "text - A number of points. PH({{amount}}|100|number of points)",
  },
  calendarMonthFormatStyle: DateTimeFormatStyle.Custom({
    month: "long",
    year: "numeric",
  }),
};

const arabicConfig: TranslatableBrandAttributes = {
  ...defaultConfig,
  rewardsPriceFormatterKey: "{{amount}} نقاط",
  urls: {
    ...defaultConfig.urls,
    termsAndConditions: "https://hts.hopper.com/legal/ar-HSBC-QA",
    privacyPolicy: "https://hts.hopper.com/legal/ar-privacy-policy",
    cfarTerms: "https://hts.hopper.com/legal/ar-HSBC-QA",
    disruptionTerms: "https://hts.hopper.com/legal/ar-HSBC-QA",
    hsbcTerms: "https://www.hsbc.com.qa/ar-qa/terms/",
  },
};

export const branding: Branding = {
  clientName: ClientName.HSBC_QA,
  currencies: [
    {
      locale: "en-GB",
      code: "QAR",
      symbol: "QAR",
      symbolOverride: "QAR ",
    },
  ],
  contactSupport: {
    chatAvailability: ChatAvailability.None,
    displaySupportNumber: "00800100273",
    displayIntlSupportNumber: "+44 20 4632 2359",
    supportNumber: "00800100273",
    intlSupportNumber: "+442046322359 ",
  },
  [I18nNamespace.translation]: {
    [TranslationLanguage.ar]: arabicConfig,
    [TranslationLanguage["en-GB"]]: defaultConfig,
  },
  default: "en-GB",
  // TODO: AR is here for config only
  supportedLanguages: [
    { key: "en-GB", name: "English", label: "English" },
    { key: "ar", name: "Arabic", label: "العربية" },
  ],
  merchantPayments: "",
  hidePaymentZipCode: true,
  showAIChat: false,
};
